// extracted by mini-css-extract-plugin
export default {"listingAge":"ListingAge-module__listingAge___EoWHC","dateAgo":"ListingAge-module__dateAgo___xmM8y","strikeThrough":"ListingAge-module__strikeThrough___LoORR"};